export default __webpack_public_path__ + "static/media/doge.933c8170.svg";